<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { cloneDeep, orderBy } from "lodash";
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import AttachmentModal from "@/components/modals/attachment-modal.vue";
import Swal from "sweetalert2";

export default {
    page: {
        title: "Faculties",
    },
    components: {
        Layout,
        PageHeader,
        Multiselect,
        AttachmentModal
    },
    data() {
        return {
            title: "Faculties",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Faculties",
                    active: true,
                },
            ],
            tableData: [],
            engagements: [
                {
                    id: 1,
                    value: "A",
                    name: "Pursuing advanced research programs (Doctorate)",
                    valueName: 'Category A - Pursuing advanced research programs (Doctorate)',
                },
                {
                    id: 2,
                    value: "B",
                    name: "Actively pursuing research within the last 3 years",
                    valueName: 'Category B - Actively pursuing research within the last 3 years',
                },
                {
                    id: 3,
                    value: "C",
                    name: "Producing technologies or livelihood improvement",
                    valueName: 'Category C - Producing technologies or livelihood improvement',
                },
                {
                    id: 4,
                    value: "D",
                    name: "Whose research work resulted in an extension program",
                    valueName: 'Category D - Whose research work resulted in an extension program',
                },
                {
                    id: 5,
                    value: "E",
                    name: "None of the above",
                    valueName: 'Category E - None of the above',
                },
            ],
            fields: [
                {
                    key: "faculty",
                    sortable: true,
                    label: "Faculty",
                },
                {
                    key: "engagement",
                    sortable: true,
                },
                {
                    key: "actions",
                    thStyle: { width: "100px" },
                },
            ],
            form: {
                id: 0,
                deliveryUnitId: null,
                idNumbers: null
            },
            engagement: null,
            deliveryUnit: null,
            indexSelected: null,
            perPage: 10,
            currentPage: 1,
            pageOptions: [10, 25, 50, 100],
            sortDesc: false,
            tableBusy: false,
            filter: null,
            filterOn: [],
            sortBy: "",
            modalTitle: "",
            attWActions: true,
            uploadTitle: null,
            facultyLoading: false,
            facultySelection: false,
            filterFaculty: "",
            selectedFaculty: [],
            available: [],
            faculty: [],
            filterEmploymentType: 'All',
            selectedEngagements: [],
        };
    },
    validations: {
        form: {
            deliveryUnitId: {
                required,
            },
        },
    },
    computed: {
       rows() {
            let data = this.tableData;
            if(this.filterEmploymentType.toLowerCase() !== 'all'){
                data = data.filter((item) => {return item.employmentType.toLowerCase().includes(this.filterEmploymentType.toLowerCase())});
            }
            if (this.filter && this.filter.trim() != "") {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data.length;
        },
        filteredEmploymentType(){
            let data = this.tableData;
            if(this.filterEmploymentType.toLowerCase() !== 'all'){
                data = data.filter((item) => {
                    return item.employmentType.toLowerCase().includes(this.filterEmploymentType.toLowerCase());
                });
            }
            return data;
        },
        filteredFaculties(){
            let data = this.available;
            if (this.filterFaculty.trim() != "" && this.filterFaculty) {
                data = data.filter((item) => {
                    return item.fullName
                        .toUpperCase()
                        .includes(this.filterFaculty.toUpperCase());
                });
            }
            return data;
        }
    },
    async created() {
        this.pageLoader(true);
        await this.getFaculties(this.$store.state.data.selectedDU.id);
        await this.getAvailableFaculties();
        this.pageLoader(false);
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        async getAvailableFaculties() {
            await this.$store
                .dispatch("faculty/GetAvailableFaculties")
                .then((response) => {
                    response.data.forEach((item) => {
                        let middleName = item.middleName ? item.middleName : "";
                        item.fullName = item.lastName.trim() + ", " + item.firstName.trim() + " " + middleName;
                    });
                    this.available = orderBy(response.data, ['fullName'], ['asc'])
                })
                .catch((error) => {
                    this.showToast(
                        "Something went wrong - getting available faculties",
                        "error"
                    );
                });
        },
        async getFaculties(deliveryUnitId) {
            this.tableBusy = true;
            await this.$store
                .dispatch("faculty/GetFacultyByDU", deliveryUnitId)
                .then((response) => {
                    response.data.forEach((item) => {
                        let middleName = item.accountableOfficer.middleName ? item.accountableOfficer.middleName : "";
                        item.fullName = item.accountableOfficer.lastName + ", " + item.accountableOfficer.firstName + " " + middleName;
                        let facultyEngagements = [];
                        if(item.facultyEngagement){
                            let engagements = item.facultyEngagement.split(',');
                            engagements.forEach((engagement) => {
                                let findEngagement = this.engagements.find((item) => { return item.value === engagement });
                                if(findEngagement){
                                    facultyEngagements.push(findEngagement);
                                }
                            });
                        }
                        item.facultyEngagements = facultyEngagements;
                        item.employmentType = item.accountableOfficer.employmentType.toLowerCase() === 'permanent' ? 'Permanent' : 'Part Time';
                        item.filterKey = `${item.accountableOfficer.lastName.trim()} ${item.accountableOfficer.firstName.trim()} `
                    });
                    this.tableData = orderBy(response.data, ['fullName'], ['asc'])
                })
                .catch((error) => {
                    console.log(error);
                    this.showToast("Something went wrong - getting faculties", "error");
                });
            this.tableBusy = false;
        },
        addFaculty() {
            this.onReset();
            this.modalTitle = "Create New Faculty";
            this.$bvModal.show("add-faculty");
        },
        onCreate() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                return;
            }
            let engagements = [];
            this.selectedEngagements.forEach((item) => {
                engagements.push(item.value);
            });
            this.form.facultyEngagement = engagements.toString();
            if (this.form.id > 0) {
                this.$store
                    .dispatch("faculty/UpdateFaculty", this.form)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        let middleName = res.data.accountableOfficer.middleName ? res.data.accountableOfficer.middleName : "";
                        res.data.fullName = res.data.accountableOfficer.lastName + ", " + res.data.accountableOfficer.firstName + " " + middleName;
                        res.data.facultyEngagements = this.selectedEngagements;
                        this.tableData.splice(this.indexSelected, 1, res.data);
                        this.$bvModal.hide("modal-standard");
                        this.showToast("Successfully updated!", "success");
                    })
                    .catch((err) => {
                        console.log(err)
                        this.showToast("Something went wrong!", "error");
                    });
            } else {
                if(this.selectedFaculty.length == 0){
                    return this.showToast("Please select at least one faculty", "warning");
                }
                let data = {
                    deliveryUnitId: this.form.deliveryUnitId,
                    idNumbers: [],
                }
                this.selectedFaculty.forEach((item) => {
                    data.idNumbers.push(item.idNo);
                });
                this.$store
                    .dispatch("faculty/AddMultipleFaculty", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        this.getFaculties(this.$store.state.data.selectedDU.id);
                        this.$bvModal.hide("add-faculty");
                        this.showToast("Successfully created!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
            this.submitted = false;
        },
        async updateItem(props) {
            this.indexSelected = this.tableData.indexOf(props.item);
            this.form = cloneDeep(props.item);
            this.selectedEngagements = props.item.facultyEngagements;
            this.modalTitle = "Update Faculty";
            this.$bvModal.show("modal-standard");
        },
        async facultyAttachments(props) {
            this.uploadTitle = `Faculty Attachments`;
            this.$refs.attachmentModal.setUploadOpt({
                type: `Faculty`,
                placement: "left",
                folder: "Planning",
            });
            this.$refs.attachmentModal.getData(this.$store.state.data.selectedDU.id);
            this.$bvModal.show("upload-attachment-modal");
        },
        onReset() {
            this.form = {
                id: 0,
                deliveryUnitId: this.$store.state.data.selectedDU.id,
                idNumbers: [],
            };
            this.campus = null;
            this.selectedFaculty = [];
            this.selectedEngagements = [];
            this.deliveryUnit = null;
            this.$v.form.$reset();
        },
        openFacultySelection() {
            this.facultySelection = true;
            this.openFaculty = true;
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$refs.inputFaculty.focus();
                }, 500);
            });
        },
        closeFaculty() {
            if (this.facultySelection) {
                this.facultySelection = false;
            }
            this.openFaculty = false;
        },
        selectFacultyFL(row){
            this.selectedFaculty.push(row);
            this.available.splice(this.available.indexOf(row), 1);
            this.filterFaculty = '';
            this.$refs.inputFaculty.focus();
        },
        removeFaculty(index){
            this.available.unshift(this.selectedFaculty[index]);
            this.selectedFaculty.splice(index, 1);
        },
        selectCampus(item){
            this.searchDU(item);
        },
        deleteItem(props) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    let index = this.tableData.indexOf(props.item);
                    this.$store
                        .dispatch("faculty/DeleteFaculty", props.item.id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "error"
                                );
                            }
                            this.tableData.splice(index, 1);
                            this.showToast("Successfully deleted!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        generateReport(){

        }
    },
};
</script>
<template>
    <Layout @changeDU="getFaculties($event.id)">
        <PageHeader :title="title" :items="items" />
        <b-modal
            id="modal-standard"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form
                @submit.prevent="onCreate"
                class="needs-validation"
                ref="fcForm"
            >
                <div class="mb-3">
                    <label for="facultyEngagement" class="form-label"
                        >Faculty Engagement</label
                    >
                    <multiselect
                        v-model="selectedEngagements"
                        :options="engagements"
                        label="valueName"
                        track-by="id"
                        value="id"
                        deselect-label=""
                        select-label=""
                        :allow-empty="true"
                        :multiple="true"
                    />
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Save changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('modal-standard')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal
            id="add-faculty"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form
                @submit.prevent="onCreate"
                class="needs-validation"
                ref="fcForm"
            >
                <div class="mb-2">
                    <label class="m-0" for="campus">Faculty </label>
                    <div v-if="this.form.id == 0">
                        <div v-if="facultyLoading">
                            <div class="d-flex justify-content-center m-3">
                                <i class="bx bx-loader font-size-30"></i>
                            </div>
                        </div>
                        <div v-if="!facultyLoading">
                            <div
                                class="
                                    cursor-pointer
                                    py-3
                                    px-2
                                    br-5
                                    border-dashed-1
                                    position-relative
                                "
                                style="min-height: 50px"
                                v-if="!facultySelection"
                            >
                                <div
                                    class="
                                        position-absolute
                                        w-100
                                        d-flex
                                        align-items-center
                                        justify-content-center
                                    "
                                    style="top: 0; left: 0; bottom: 0; right: 0"
                                    @click="openFacultySelection"
                                >
                                    <h5
                                        class="mb-0 text-muted text-center"
                                        v-if="selectedFaculty.length == 0"
                                    >
                                        Click to Select Faculties
                                    </h5>
                                </div>
                                <div
                                    class="w-100"
                                    style="
                                        top: 10px;
                                        left: 10px;
                                        bottom: 10px;
                                        right: 10px;
                                    "
                                    v-if="selectedFaculty.length > 0"
                                >
                                    <div class="multiselect__tags-wrap">
                                        <span
                                            class="multiselect__tag"
                                            v-for="(du, index) in selectedFaculty"
                                            :key="du.id"
                                        >
                                            <span>{{ du.fullName }}</span>
                                            <i
                                                class="multiselect__tag-icon"
                                                @click="removeFaculty(index)"
                                            ></i
                                        ></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="py-3 br-5 border-dashed-1 position-relative"
                            v-if="facultySelection"
                            v-click-outside="closeFaculty"
                        >
                            <div class="px-2">
                                <div class="multiselect__tags-wrap">
                                    <span
                                        class="multiselect__tag"
                                        v-for="(fac, index) in selectedFaculty"
                                        :key="fac.id"
                                    >
                                        <span>{{ fac.fullName }}</span>
                                        <i
                                            class="multiselect__tag-icon"
                                            @click="removeFaculty(index)"
                                        ></i
                                    ></span>
                                </div>
                            </div>
                            <input
                                type="text"
                                class="custom-inline-form w-100 text-center"
                                placeholder="Search Faculty"
                                @click="openFaculty = true"
                                v-model="filterFaculty"
                                ref="inputFaculty"
                            />
                            <div
                                class="
                                    selection-wrapper
                                    position-absolute
                                    w-100
                                "
                                v-if="openFaculty"
                            >
                                <ul class="multiselect__content text-left">
                                    <template v-if="available.length == 0">
                                        <li>
                                            <span class="multiselect__option"
                                                >No data found</span
                                            >
                                        </li>
                                    </template>
                                    <template
                                        v-if="
                                            available.length > 0 &&
                                            filteredFaculties.length == 0
                                        "
                                    >
                                        <li>
                                            <span class="multiselect__option"
                                                >Search not found</span
                                            >
                                        </li>
                                    </template>
                                    <li
                                        class="multiselect__element"
                                        v-for="x in filteredFaculties"
                                        :key="x.id"
                                        @click="selectFacultyFL(x)"
                                    >
                                        <span class="multiselect__option">{{
                                            x.fullName
                                        }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <input
                        class="form-control"
                        v-model="form.fullName"
                        disabled
                        v-if="form.id > 0"
                    />
                    <div
                        v-if="submitted && faculty.length == 0"
                        class="invalid-feedback"
                    >
                        <span>This value is required.</span>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Save changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('add-faculty')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <div class="card border">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6 d-flex align-items-center">
                        <h4 class="card-title m-0 text-nowrap me-2">
                            Faculty List
                        </h4>
                        <button
                            class="btn rounded-pill me-2"
                            :class="{
                                'btn-light': filterEmploymentType !== 'All',
                                'btn-warning': filterEmploymentType === 'All',
                            }"
                            type="button"
                            @click="filterEmploymentType = 'All'"
                        >
                            <span class="px-3">All</span>
                        </button>
                        <button
                            class="btn rounded-pill me-2"
                            :class="{
                                'btn-light': filterEmploymentType !== 'Permanent',
                                'btn-warning': filterEmploymentType === 'Permanent',
                            }"
                            type="button"
                            @click="filterEmploymentType = 'Permanent'"
                        >
                            <span class="px-3">Permanent</span>
                        </button>
                        <button
                            class="btn rounded-pill"
                            :class="{
                                'btn-light': filterEmploymentType !== 'Part Time',
                                'btn-warning': filterEmploymentType === 'Part Time',
                            }"
                            type="button"
                            @click="filterEmploymentType = 'Part Time'"
                        >
                            <span class="px-3">Part Time</span>
                        </button>
                    </div>
                    <div class="col-md-6">
                        <div class="d-flex justify-content-end">
                            <button
                                class="btn btn-primary me-2"
                                @click="generateReport"
                            >
                                Generate Report
                            </button>
                            <button
                                class="btn btn-primary me-2"
                                @click="facultyAttachments"
                            >
                                <i class="fas fa-paperclip me-2"></i>
                                Attachments
                            </button>
                            <button
                                type="button"
                                @click="addFaculty"
                                class="btn btn-info d-flex align-items-center"
                            >
                                <i class="bx bx-plus fs-6"></i>Create New
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-sm-12 col-md-6">
                        <div
                            id="tickets-table_length"
                            class="dataTables_length"
                        >
                            <label class="d-inline-flex align-items-center">
                                Show&nbsp;
                                <b-form-select
                                    class="form-select form-select-sm"
                                    v-model="perPage"
                                    size="sm"
                                    :options="pageOptions"
                                ></b-form-select
                                >&nbsp;entries
                            </label>
                        </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-12 col-md-6">
                        <div
                            id="tickets-table_filter"
                            class="dataTables_filter text-md-end"
                        >
                            <label class="d-inline-flex align-items-center">
                                Search:
                                <b-form-input
                                    autocomplete="off"
                                    v-model="filter"
                                    type="search"
                                    placeholder="Search..."
                                    class="form-control form-control-sm ms-2"
                                ></b-form-input>
                            </label>
                        </div>
                    </div>
                    <!-- End search -->
                </div>
                <div class="table-responsive mb-0">
                    <b-table
                        class="datatables"
                        :items="filteredEmploymentType"
                        :fields="fields"
                        responsive="sm"
                        :per-page="perPage"
                        :current-page="currentPage"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        :filter="filter"
                        :filter-included-fields="filterOn"
                        :busy="tableBusy"
                        @filtered="onFiltered"
                        bordered
                        outlined
                        hover
                        striped
                        show-empty
                    >
                        <template #empty="scope">
                            <div class="text-center">
                                {{ scope.emptyText }}
                            </div>
                        </template>
                        <template #table-busy>
                            <div
                                class="
                                    d-flex
                                    justify-content-center
                                    align-items-center
                                "
                            >
                                <div class="preloader-component me-2">
                                    <div class="status">
                                        <div
                                            class="spinner-chase w-20px h-20px"
                                        >
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                            <div class="chase-dot"></div>
                                        </div>
                                    </div>
                                </div>
                                <strong>Loading...</strong>
                            </div>
                        </template>
                        <template #cell(faculty)="row">
                            <div class="d-flex align-items-center">
                                <div class="avatar-sm me-2">
                                    <span
                                        class="
                                            avatar-title
                                            rounded-circle
                                            bg-soft bg-primary
                                            text-primary
                                            font-size-16
                                        "
                                        >{{
                                            row.item.accountableOfficer.firstName
                                                .charAt(0)
                                                .toUpperCase()
                                        }}{{
                                            row.item.accountableOfficer.lastName
                                                .charAt(0)
                                                .toUpperCase()
                                        }}</span
                                    >
                                </div>
                                <div>
                                    <div class="mt-1">
                                        <h5 class="mb-0">
                                            {{
                                                row.item.accountableOfficer.lastName
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                row.item.accountableOfficer.lastName.slice(
                                                    1
                                                )
                                            }},
                                            {{
                                                row.item.accountableOfficer.firstName
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                row.item.accountableOfficer.firstName.slice(
                                                    1
                                                )
                                            }}
                                            {{
                                                row.item.accountableOfficer
                                                    .middleName
                                                    ? `${row.item.accountableOfficer.middleName
                                                          .charAt(0)
                                                          .toUpperCase()}.`
                                                    : ""
                                            }}
                                        </h5>
                                    </div>
                                    <div>
                                        {{
                                            row.item.accountableOfficer.position
                                        }}
                                    </div>
                                    <i>{{
                                        row.item.accountableOfficer.idNo
                                    }}</i>
                                </div>
                            </div>
                        </template>
                        <template #cell(engagement)="row">
                            <div class="d-flex" v-if="row.item.facultyEngagements.length == 0">
                                <span>Not assigned yet.</span>
                                <div class="d-flex align-items-center ms-1"><small>[<a href="javascript:void(0);" @click="updateItem(row)">Assign engagement</a>]</small></div>
                            </div>
                            <div v-else>
                                <div v-for="engagement in row.item.facultyEngagements" :key="engagement.id">
                                    {{engagement.name}}
                                </div>
                                <div class="mt-2">
                                    <a href="javascript:void(0);" class="text-success hover-link" @click="updateItem(row)">Update Engagement</a>
                                </div>
                            </div>
                        </template>
                        <template #cell(actions)="row">
                            <div class="float-end">
                                <b-dropdown
                                    id="dropdown-dropleft"
                                    right
                                    variant="link"
                                    toggle-class="text-decoration-none"
                                    menu-class="dropdown-menu-end"
                                    no-caret
                                >
                                    <template #button-content>
                                        <i class="fas fa-ellipsis-v"></i>
                                    </template>
                                    <b-dropdown-item
                                        @click="deleteItem(row)"
                                        variant="danger"
                                        ><i
                                            class="
                                                mdi mdi-trash-can
                                                font-size-18
                                                me-1
                                            "
                                        ></i
                                        >Delete</b-dropdown-item
                                    >
                                </b-dropdown>
                            </div>
                        </template>
                    </b-table>
                </div>
                <div class="row">
                    <div class="col">
                        <div
                            class="
                                dataTables_paginate
                                paging_simple_numbers
                                float-end
                            "
                        >
                            <ul class="pagination pagination-rounded mb-0">
                                <!-- pagination -->
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="rows"
                                    :per-page="perPage"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <attachment-modal
            :wActions="attWActions"
            :title="uploadTitle"
            ref="attachmentModal"
        ></attachment-modal>
    </Layout>
</template>